if (!customElements.get('athraah-footer-accordion')) {
  class AthraahFooterAccordion extends HTMLElement {
    connectedCallback() {
      this.addEventListener('click', this.handleClick.bind(this));
    }

    handleClick(event) {
      const trigger = event.target.closest('[data-accordion-trigger]');
      if (!trigger) return;

      const item = trigger.closest('[data-accordion-item]');
      if (!item) return;

      const isOpen = item.classList.contains('athraah-footer__col--open');
      item.classList.toggle('athraah-footer__col--open', !isOpen);
      trigger.setAttribute('aria-expanded', String(!isOpen));
    }
  }

  customElements.define('athraah-footer-accordion', AthraahFooterAccordion);
}
